// Default the "In stock" availability filter on collection pages when no filter is set.
// Skipped when coming from the same collection so shoppers can still clear it.
(function () {
  try {
    var url = new URL(window.location.href);
    var hasFilter = Array.from(url.searchParams.keys()).some(function (k) { return k.indexOf('filter.') === 0; });
    var ref = document.referrer ? new URL(document.referrer) : null;
    var sameCollection = ref && ref.origin === url.origin && ref.pathname === url.pathname;
    if (hasFilter || sameCollection) return;
    url.searchParams.set('filter.v.availability', '1');
    window.location.replace(url.toString());
  } catch (e) {}
})();
